import { makeStyles } from '@material-ui/core';

export const usePriceHistoryStyles = makeStyles(() => ({
  chart: {
    height: '294px',
  },
}));
